import Content from "./Content";

const PageWithSideBar = ({ content }) => {
    return (
        <div className="col-md-9">
            <Content htmldata={content} />
        </div>
    );
};

export default PageWithSideBar;